import { toastController } from '@ionic/vue';

interface App {
  handle: string,
  name: string,
  resource: string,
  type: string,
  appPermission?: string,
  appLegacyPermission?: string
}

const appInfo = [{
  handle: 'cycle-count',
  name: 'Cycle Count',
  resource: require('../assets/images/Inventory.svg'),
  type: 'Warehouse'
}, {
  handle: 'packing',
  name: 'Packing',
  resource: require('../assets/images/Fulfillment.svg'),
  type: 'Warehouse'
}, {
  handle: 'receiving',
  name: 'Receiving',
  resource: require('../assets/images/Receiving.svg'),
  type: 'Warehouse'
}, {
  handle: 'picking',
  name: 'Picking',
  resource: require('../assets/images/Picking.svg'),
  type: 'Warehouse'
}, {
  handle: 'inventory',
  name: 'Inventory',
  resource: require('../assets/images/Inventory.svg'),
  type: 'Warehouse'
}, {
  handle: 'users',
  name: 'Users',
  resource: require('../assets/images/UserManagement.svg'),
  type: 'Administration'
}, {
  handle: 'facilities',
  name: 'Facilities',
  resource: require('../assets/images/Facilities.svg'),
  type: 'Administration'
}, {
  handle: 'job-manager',
  name: 'Job Manager',
  resource: require('../assets/images/JobManager.svg'),
  type: 'Administration'
},
{
  handle: 'order-routing',
  name: 'Order Routing',
  resource: require('../assets/images/OrderRouting.svg'),
  type: 'Administration'
}] as App[]

const showToast = async (message: string) => {
  const toast = await toastController
    .create({
      message,
      duration: 3000,
      position: 'bottom',
    })
  return toast.present();
}

export { appInfo, showToast }
